// Angular
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fieldRequiredIfOtherFilledValidator(field1: AbstractControl): ValidatorFn {
  return (field2: AbstractControl): ValidationErrors | null => {
    if (field1.value && !field2.value) {
      return { fieldRequiredIfOtherFilled: true }; // Validation error
    }
    return null; // No validation error
  };
}
